import React from "react";
import { Link } from 'react-router-dom';

export default function ForCompanies() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.currentTarget;
    target.src = "https://via.placeholder.com/720x560?text=Image+unavailable";
    target.alt = "Image failed to load";
  };

  return (
    <section className="relative py-8 md:py-14 bg-white overflow-hidden">
      <div className="relative mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="relative bg-[#0f0f0f] rounded-[24px] md:rounded-[40px] overflow-hidden">
          <div className="absolute top-20 left-10 w-32 h-32 border border-[#F49729]/20 rotate-45 z-[1]"></div>
          <div className="absolute top-40 left-20 w-20 h-20 border border-[#F49729]/10 rotate-12 z-[1]"></div>
          <div className="absolute bottom-32 right-1/3 w-3 h-3 bg-[#F49729] rounded-full z-[1]"></div>
          <div className="absolute top-1/3 left-1/4 w-2 h-2 bg-[#F49729]/60 rounded-full z-[1]"></div>

          <div className="relative z-10 grid lg:grid-cols-2 gap-0 lg:gap-12 items-center">
            {/* Image — top on mobile */}
            <div className="relative order-1 lg:order-2 w-full h-[220px] sm:h-[300px] md:h-[380px] lg:h-[500px] lg:rounded-none overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20business%20team%20meeting%20in%20modern%20glass%20conference%20room%20diverse%20executives%20discussing%20strategy%20warm%20natural%20lighting%20corporate%20environment%20elegant%20office%20interior%20amber%20warm%20tones%20professional%20photography%20shallow%20depth%20of%20field&width=720&height=560&seq=2&orientation=landscape"
                alt="Business team meeting"
                className="w-full h-full object-cover object-center"
                onError={handleImgError}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>

            {/* Content */}
            <div className="order-2 lg:order-1 px-5 sm:px-8 lg:px-16 py-8 md:py-16 lg:py-24">
              <div className="max-w-lg">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F49729]/10 border border-[#F49729]/30 rounded-full mb-5 md:mb-6">
                  <i className="ri-building-2-line text-[#F49729]"></i>
                  <p className="text-[#F49729] text-xs font-semibold tracking-[0.2em] uppercase">
                    For Companies
                  </p>
                </div>
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 md:mb-6">
                  Build Your Team
                  <br />
                  <span className="text-[#F49729]">With Confidence</span>
                </h2>
                <p className="text-sm text-white/70 leading-relaxed mb-6 md:mb-8">
                  Working with a new provider shouldn't mean losing visibility. You'll know exactly who you're getting, and you'll have our support well beyond the intro.
                </p>
                <div className="grid grid-cols-2 gap-2 md:gap-4 mb-7 md:mb-10">
                  {[
                    { icon: "ri-eye-line", text: "Full Transparency" },
                    { icon: "ri-user-voice-line", text: "No Middlemen" },
                    { icon: "ri-chat-check-line", text: "Same-Day Responses" },
                    { icon: "ri-refresh-line", text: "30-Day Free Replacement" },
                  ].map((item, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-2 p-2.5 bg-white/5 rounded-xl border border-white/10 hover:border-[#F49729]/30 transition-colors"
                    >
                      <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#F49729]/20 text-[#F49729] flex-shrink-0">
                        <i className={`${item.icon} text-sm`}></i>
                      </span>
                      <span className="text-xs text-white/80 leading-snug">{item.text}</span>
                    </div>
                  ))}
                </div>
                <Link
                  to="/hire-talent"
                  className="inline-flex items-center px-6 py-3 text-xs font-semibold tracking-wider text-black bg-[#F49729] rounded-full hover:bg-[#ffaa4d] hover:shadow-[0_0_30px_rgba(244,151,41,0.4)] transition-all cursor-pointer whitespace-nowrap"
                >
                  HIRE TALENT
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
